import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { mediaQueries } from 'shared/styles';
import { useUser } from 'src/hooks/use-user';
import { getAdminAssetUrl } from 'src/utils/admin-asset-url';

type SidebarHeaderProps = {
  imageSrc?: string;
  title: ReactNode;
};

export function SidebarHeader(props: SidebarHeaderProps): JSX.Element {
  const user = useUser();
  const { imageSrc, title } = props;

  return (
    <Container>
      {/* No dispensary-branded logo to fall back on (e.g. super admin, chain admin, enterprise
          admin) -- use the current Dutchie brand mark (dutchie-mark-sand.svg) rather than the
          retired four-petal flower (dutchie-logo-sand.svg). */}
      <Image src={imageSrc ?? getAdminAssetUrl('/icons/dutchie-mark-sand.svg')} />
      <TitleText data-testid='admin-title'>{title}</TitleText>
      <EmailText data-testid='admin-email'>{user.email}</EmailText>
      <Divider />
    </Container>
  );
}

const Container = styled.div`
  flex: 0 0 auto;
  margin-top: 37px;
`;

const Image = styled.img`
  display: block;
  margin: 0 auto;
  width: 70px;
  max-width: 70px;
  padding-bottom: 10px;

  @media ${mediaQueries.desktop} {
    width: 90%;
  }
`;

const TitleText = styled.div`
  display: block;
  font-weight: bold;
  margin-top: 18px;
  padding: 0 5px;
  text-align: center;
`;

const EmailText = styled.div`
  color: #f1e8d6;
  font-size: 12px;
  margin: 2px 0 24px 0;
  overflow: hidden;
  padding: 0 5px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${mediaQueries.desktop} {
    display: none;
  }
`;

const Divider = styled.hr`
  background-color: #1a5c42;
  border: none;
  display: block;
  height: 1px;
  margin: 16px auto 24px;
  width: 77%;
`;
